export function formatDateTime(value: string | undefined, timeZone = 'Asia/Shanghai') {
  if (!value) {
    return '等待更新'
  }

  const date = new Date(value)
  if (Number.isNaN(date.getTime())) {
    return '时间无效'
  }

  try {
    return new Intl.DateTimeFormat('zh-CN', {
      timeZone,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false,
    }).format(date)
  } catch {
    return new Intl.DateTimeFormat('zh-CN', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false,
    }).format(date)
  }
}

